module.exports = __webpack_public_path__ + "assets/img/ETH.492c92fa.png";